export default "__VITE_ASSET__Kt5zaa7k__"